import React, { type ReactNode } from 'react';
import { HorizontalScrollView } from '@atlassian/jira-portfolio-3-horizontal-scrolling';

export default function wrapHorizontalScrollView(wrapped: ReactNode) {
	return <HorizontalScrollView>{wrapped}</HorizontalScrollView>;
}

// eslint-disable-next-line jira/export/no-external-exports
export { HorizontalScrollView };
